import { queryOptions } from "@tanstack/react-query";

import { apiGet } from "@softmax/observatory-client/client";

import { backendFetch } from "@softmax/observatory-client/transport";

import type { Schemas } from "@softmax/observatory-client/types";

export const viewerProgressQueryOptions = () =>
  queryOptions({
    queryKey: ["viewer", "progress", { elevatedPrivileges: false }],
    queryFn: ({ signal }) =>
      backendFetch<[string, string][]>("", "/api/viewer-progress", {
        signal: signal,
      }),
    staleTime: 30_000,
  });

export const championEpisodesQueryOptions = (policyVersionId: string) =>
  queryOptions({
    queryKey: [
      "viewer",
      "champion-episodes",
      { policyVersionId, limit: 25, elevatedPrivileges: false },
    ],
    queryFn: ({ signal }) =>
      apiGet<Schemas["EpisodePage"]>(
        `/v2/policy-versions/${encodeURIComponent(policyVersionId)}/episodes?limit=25`,
        { signal, elevatedPrivileges: false },
      ),
    staleTime: 30_000,
  });
